import script from "./SecureDisclaimer.vue?vue&type=script&setup=true&lang=js"
export * from "./SecureDisclaimer.vue?vue&type=script&setup=true&lang=js"

import "./SecureDisclaimer.vue?vue&type=style&index=0&id=7a52069a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a52069a"]])

export default __exports__